var render = function render(){var _vm=this,_c=_vm._self._c;return _c('patch-causes-template',{attrs:{"age":_vm.age,"first-patch-occurrences":_vm.firstPatchOccurrences,"patch-causes":_vm.patchCauses,"field-errors":_vm.fieldErrors},on:{"field-change":_vm.onFieldChange}})
}
var staticRenderFns = []

export { render, staticRenderFns }